import { render } from "./CreateMaster.vue?vue&type=template&id=6a169532"
import script from "./CreateMaster.vue?vue&type=script&lang=js"
export * from "./CreateMaster.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__